import { Component, computed, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import {
  CardComponent,
  CoreHostDirective,
  ProgressBarComponent,
  ProgressBarSize,
} from '@solcre-org/core-ui';
import { VoyageSegmentModel } from '../../../../shared/models/voyage-segment.model';
import { VoyageSummaryModel } from '../../../../shared/models/voyage-summary.model';

@Component({
  selector: 'app-voyage-used',
  imports: [TranslateModule, ProgressBarComponent],
  templateUrl: './voyage-used.html',
  hostDirectives: [CoreHostDirective],
})
export class VoyageUsed {
  //Inputs and outputs
  activeVoyage = input<VoyageSummaryModel | null>(null);
  activeVoyageSegment = input<VoyageSegmentModel | null>(null);
  arrivalVoyageSegment = input<VoyageSegmentModel | null>(null);
  departureVoyageSegment = input<VoyageSegmentModel | null>(null);
  changeVoyageSegmentActive = output<VoyageSegmentModel | null>();

  //Models
  progressBarSizeConfig: ProgressBarSize = ProgressBarSize.NORMAL;

  //Computed
  //Whether the currently displayed segment is the arrival ("before the call") snapshot.
  isShowingArrival = computed(() => {
    const active = this.activeVoyageSegment();
    const arrival = this.arrivalVoyageSegment();
    return !!active && !!arrival && active.id === arrival.id;
  });

  //Occupied-capacity delta between arrival and departure, i.e. what this call moved.
  variation = computed(() => {
    const arrival = this.arrivalVoyageSegment();
    const departure = this.departureVoyageSegment();
    if (!arrival || !departure) return null;

    return {
      linearMeters: (departure.occupiedCapacity.linearMeters ?? 0) - (arrival.occupiedCapacity.linearMeters ?? 0),
      squareMeters: (departure.occupiedCapacity.squareMeters ?? 0) - (arrival.occupiedCapacity.squareMeters ?? 0),
      weightTons: (departure.occupiedCapacity.weightTons ?? 0) - (arrival.occupiedCapacity.weightTons ?? 0),
    };
  });

  //Events
  onArrival(): void {
    this.changeVoyageSegmentActive.emit(this.arrivalVoyageSegment());
  }
  onDeparture(): void {
    this.changeVoyageSegmentActive.emit(this.departureVoyageSegment());
  }
}
